// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.settings.`data`.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import one.healthium.settings.`data`.dto.SettingsItemDto

@OptIn(InternalKtorfitApi::class)
public class _SettingsApiClientImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : SettingsApiClient {
  override suspend fun getMenu(menuId: String, locale: String): List<SettingsItemDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/${"$menuId".encodeURLPath()}.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<SettingsItemDto>>(),)!! 
  }
}

public class _SettingsApiClientProvider : ClassProvider<SettingsApiClient> {
  override fun create(_ktorfit: Ktorfit): SettingsApiClient = _SettingsApiClientImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createSettingsApiClient(): SettingsApiClient = _SettingsApiClientImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
